import { Icon_Sidebar24 } from "@shapr3d/frontend-lib";
import classNames from "classnames";
import { useParams } from "react-router-dom";

import useNavigation from "../../hooks/navigation";
import { useTracker } from "../../hooks/useTracker";
import { useWebExport } from "../../hooks/useWebExport";
import { DeepLinkModal } from "../DeepLinkModal/DeepLinkModal";
import { OverlayProvider } from "../Headers/components/ShareModal/components/MenuPortal";
import { Toolbar } from "../Toolbar/Toolbar";
import { ToolButton } from "../ToolButton/ToolButton";
import { ProjectMetadata } from "./ProjectMetadata/ProjectMetadata";
import { ProjectVersionSelector } from "./ProjectVersionSelector/ProjectVersionSelector";

import style from "./ProjectSidebar.module.css";

interface ProjectSidebarProps {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  isCommentingEnabled: boolean;
}

export const ProjectSidebar = ({ isOpen, setOpen, isCommentingEnabled }: ProjectSidebarProps) => {
  const { data: webExportData, viewLinkId } = useWebExport();
  const { projectId = "", drawingId = "" } = useParams();
  const isPrivateCloud = Boolean(webExportData?.isPrivateCloud);

  const navigation = useNavigation();
  const tracker = useTracker();

  return (
    <div className={classNames([style.sidebarWrapper, !isOpen && style.closed])}>
      <div className={style.sidebar}>
        <ProjectMetadata />

        <OverlayProvider>
          <div className={style.versionsWrapper}>
            <ProjectVersionSelector />
            {webExportData && (
              <div className={style.modelList}>
                <button
                  className={classNames([style.listItem, !drawingId && style.active])}
                  onClick={() =>
                    navigation.goToViewLink({
                      viewLinkId: viewLinkId ?? "",
                      projectId,
                    })
                  }
                >
                  {webExportData.revision?.thumbnailDownloads?.light?.url && (
                    <div className={style.listItemIcon}>
                      <img
                        src={webExportData.revision?.thumbnailDownloads?.light?.url}
                        alt="Model Thumbnail"
                        onError={(e) => (e.currentTarget.style.display = "none")}
                      />
                    </div>
                  )}

                  <div>Model</div>
                </button>
              </div>
            )}
            {webExportData?.webExport.drawingsDownload?.length && (
              <div className={style.drawingsList}>
                <div className={style.drawingsTitle}>Drawings</div>

                {webExportData.webExport.drawingsDownload.map((drawing) => (
                  <button
                    key={drawing.drawingId}
                    className={classNames([
                      style.listItem,
                      drawing.drawingId === drawingId && style.active,
                    ])}
                    onClick={() =>
                      navigation.goToDrawing({
                        viewLinkId: viewLinkId ?? "",
                        projectId,
                        drawingId: drawing.drawingId,
                      })
                    }
                  >
                    <div>{drawing.title}</div>
                  </button>
                ))}
              </div>
            )}
          </div>
        </OverlayProvider>
      </div>
      <div className={style.controlButton}>
        <ToolButton
          alt="Project Outline"
          title="Project Outline"
          icon={<Icon_Sidebar24 />}
          onClick={() => {
            const newState = isOpen ? "close" : "open";
            tracker.trackProjectSidebarToggled({ newState });
            setOpen(!isOpen);
          }}
          isActive={isOpen}
        />
        {!isPrivateCloud && <Toolbar isDisabled={Boolean(drawingId || !isCommentingEnabled)} />}
      </div>
      <DeepLinkModal />
    </div>
  );
};
